import { render, staticRenderFns } from "./VuetifyAudio.vue?vue&type=template&id=cb278eda&scoped=true"
import script from "./VuetifyAudio.vue?vue&type=script&lang=js"
export * from "./VuetifyAudio.vue?vue&type=script&lang=js"
import style0 from "./VuetifyAudio.vue?vue&type=style&index=0&id=cb278eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb278eda",
  null
  
)

export default component.exports